export const newsInfo = state => state.newsInfo;
export const userName = state => state.userName;
export const show = state => state.show;
export const token = state => state.token;
export const userdata = state => state.userdata;
export const game = state => state.game;



// WEBPACK FOOTER //
// ./src/store/getters.js